import api from "./api";

export const mapPocStatus = {
  A: "Active",
  P: "Pending",
  D: "Deactivated",
};

export const pocDataMap = (item) => ({
  POCId: item?._id,
  name: item?.name ?? null,
  addressLine1: item?.address_line1 ?? null,
  addressLine2: item?.address_line2 ?? null,
  postcode: item?.postcode ?? null,
  city: item?.city ?? null,
  state: item?.state ?? null,
  country: item?.country ?? null,
  status: mapPocStatus[item?.status] ?? null,
  qrLink: item?.qr_link ?? null,
  createDate: item?.create_date ?? null,
  lastUpdate: item?.last_update ?? null,
  map: item?.map ?? null,
});

export const POCService = {
  getPOC: async () => {
    try {
      console.log("Calling get POC api");

      const response = await api.get(`/mapi/poc/getPocList`);

      return response.data;
    } catch (error) {
      console.error(
        "Error fetching POC list data:",
        error.response?.data || error.message
      );
      throw error;
    }
  },

  getPOCDetails: async (POCID) => {
    try {
      console.log("Calling getPOCDetails api for: ", POCID);
      console.dir(POCID, { depth: null });

      const response = await api.get(`/mapi/poc/getPocById?PocId=${POCID}`);
      console.log("Response: ", response);

      return response.data;
    } catch (error) {
      console.error(
        "Error fetching POC data:",
        error.response?.data || error.message
      );
      throw error;
    }
  },

  editPOCDetails: async (POCData) => {
    try {
      console.log("Editing POC:", POCData);

      const response = await api.post(`/mapi/poc/editPoc`, POCData);
      return response.data;
    } catch (error) {
      console.error(
        "Error updating POC details:",
        error.response?.data || error.message
      );
      throw error;
    }
  },

  addPOC: async (pocData) => {
    try {
      console.log("Adding new POC:", pocData);
      const response = await api.post(`/mapi/poc/addPoc`, pocData);
      return response.data;
    } catch (error) {
      console.error(
        "Error adding new POC:",
        error.response?.data || error.message
      );
      throw error;
    }
  },

  removePoc: async (pocId, operatorId) => {
    try {
      const requestData = {
        OperatorId: operatorId,
        PocId: pocId,
      };

      console.log("Removing POC:", requestData);

      const response = await api.post(`/mapi/poc/removePoc`, requestData);
      return response.data;
    } catch (error) {
      console.error(
        "Error removing POC:",
        error.response?.data || error.message
      );
      throw error;
    }
  },
};

export default POCService;
